"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelDrawableMarkerOffset = exports.CollectionModelDrawableMarkerOffsetMutator = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var vector_1 = require("../../../math/vector");
var drawable_1 = require("./drawable");
var CollectionModelDrawableMarkerOffsetMutator = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMarkerOffsetMutator, _super);
    function CollectionModelDrawableMarkerOffsetMutator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionModelDrawableMarkerOffsetMutator.prototype.init = function () {
        this.drawable.drawableState.Mutator.create('label', this.drawable.state.labelId, this.drawable.id);
        var label = this.drawable.label;
        var bottomY = this.drawable.drawableState.capture.resolution.height * 0.95;
        label.Mutator.move(0, bottomY);
    };
    return CollectionModelDrawableMarkerOffsetMutator;
}(drawable_1.CollectionModelDrawableMutator));
exports.CollectionModelDrawableMarkerOffsetMutator = CollectionModelDrawableMarkerOffsetMutator;
var CollectionModelDrawableMarkerOffset = /** @class */ (function (_super) {
    tslib_1.__extends(CollectionModelDrawableMarkerOffset, _super);
    function CollectionModelDrawableMarkerOffset() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tag = CollectionModelDrawableMarkerOffset.TAG;
        _this.Mutator = new CollectionModelDrawableMarkerOffsetMutator(_this);
        return _this;
    }
    CollectionModelDrawableMarkerOffset.isBaseOffset = function (t) {
        return t.tag === CollectionModelDrawableMarkerOffset.TAG;
    };
    CollectionModelDrawableMarkerOffset.state = function () {
        return {
            parentId: null,
            type: core_api_1.MarkerType.BASE_OFFSET,
            id: CollectionModelDrawableMarkerOffset.DRAWABLE_ID,
            tag: CollectionModelDrawableMarkerOffset.TAG,
            labelId: CollectionModelDrawableMarkerOffset.DRAWABLE_ID + ':label',
            x: 0,
            y: 0
        };
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "state", {
        get: function () {
            var state = this.collectionState.getFieldValue(this.instanceId);
            if (state == null) {
                return null;
            }
            state.type = core_api_1.MarkerType.BASE_OFFSET;
            state.tag = CollectionModelDrawableMarkerOffset.TAG;
            state.labelId = CollectionModelDrawableMarkerOffset.DRAWABLE_ID + ':label';
            state.x = this.x;
            state.y = this.y;
            return state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "label", {
        get: function () {
            var stateValue = this.state;
            return this.drawableState.getDrawable(stateValue.labelId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "x", {
        get: function () {
            if (this.drawableState.capture == null) {
                return 0;
            }
            return this.drawableState.capture.resolution.width / 2;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "y", {
        get: function () {
            var base = this.drawableState.base;
            if (base == null || this.drawableState.capture == null) {
                return 0;
            }
            var baseXY = base.getVector();
            var moveAmount = new vector_1.Vector(0, base.state.offset);
            return this.drawableState.collection.state.getGeometry(this.captureId).movePoint(baseXY, moveAmount).y;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "value", {
        get: function () {
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarkerOffset.prototype.getVector = function () {
        return new vector_1.Vector(this.x, this.y);
    };
    Object.defineProperty(CollectionModelDrawableMarkerOffset.prototype, "isDeletable", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    CollectionModelDrawableMarkerOffset.DRAWABLE_ID = 'offset';
    CollectionModelDrawableMarkerOffset.TAG = 'offset';
    return CollectionModelDrawableMarkerOffset;
}(drawable_1.CollectionModelDrawable));
exports.CollectionModelDrawableMarkerOffset = CollectionModelDrawableMarkerOffset;
//# sourceMappingURL=marker.offset.drawable.js.map